exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body {\n    font-family: 'Roboto', sans-serif;\n}\n.centered {\n    display: block;\n    margin: 0 auto;\n}\nh1 {\n    color: #369;\n}\n.bottom-header {\n    color: #e74c3c;\n    font-size: 500%;\n    margin: 0px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/missing/missing.component.css
// module id = 792
// module chunks = 0